import axios from 'axios';

// axios.defaults.baseURL = 'http://localhost/myAPI/action/';
axios.defaults.baseURL = 'https://staffapi.attamayyuz.or.tz/action/';
// axios.defaults.baseURL = 'https://tester.attamayyuz.or.tz/action/';
